module.exports = __webpack_public_path__ + "img/richard-acuna.2b588e98.png";